module.exports = __webpack_public_path__ + "static/media/course_sample.58ece23b.svg";